import { render, staticRenderFns } from "./Im.vue?vue&type=template&id=29550ee2&scoped=true"
import script from "./Im.vue?vue&type=script&lang=js"
export * from "./Im.vue?vue&type=script&lang=js"
import style0 from "./Im.vue?vue&type=style&index=0&id=29550ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29550ee2",
  null
  
)

export default component.exports